import axios from 'axios';

axios.defaults.withCredentials = true;

let BASE_URL = process.env.REACT_APP_API_BASE_PATH + '/access-storage';

const PRICE_CARDS_URL = BASE_URL + '/dashboardPriceCards';
const PRICE_CARD_URL = BASE_URL + '/priceCard';
const ACCEPT_ALL_URL = BASE_URL + '/updateStatusAll';
const ACCEPT_URL = BASE_URL + '/updateStatus';
const UPDATE_PRICE_URL = BASE_URL + '/updatePrice';
const REPORTS_DATA_URL = BASE_URL + '/getReportsData';
const LOGIN_URL = BASE_URL + '/userSignIn';
const LOGOUT_URL = BASE_URL + '/logout';
const AUTHENTICATE_WITH_TOKEN_URL = BASE_URL + '/authenticate';
const KPI_URL = BASE_URL + '/getKPIs';
const ADD_COMMENT_URL = BASE_URL + '/addComment';
const RAISE_ALERT_URL = BASE_URL + '/raiseAlert';
const GET_HISTORY_URL = BASE_URL + '/getHistory';
const GET_SUGGESTIONS_URL = BASE_URL + '/getSuggestions';
const APPROVE_SUGGESTION_URL = BASE_URL + '/approveSuggestion';
const GET_COMMENTS_URL = BASE_URL + '/getComments';
const GET_NOTIFICATIONS_URL = BASE_URL + '/getNotifications';
const MARK_READ_URL = BASE_URL + '/markNotificationsRead';
const GET_OVERRIDE_REPORTS_DATA_URL = BASE_URL + '/getUpdateReport';
const RESET_PASSWORD_URL = BASE_URL + '/resetPassword';
const CHANGE_PASSWORD_URL = BASE_URL + '/changePassword';
const FORGOT_PASSWORD_URL = BASE_URL + '/forgotPassword';
const VALIDATE_TOKEN_URL = BASE_URL + '/validateToken';
const GET_COMPETITORS_DATA = BASE_URL + '/getCompetitorsData';
const COMPETITORS_DATA = BASE_URL + '/competitors';
const GET_USERS_WITH_REGIONS = BASE_URL + '/getUsersWithRegions';
const DELEGATE_ACCESS = BASE_URL + '/delegateAccess';
const GET_DELEGATED_RECORDS = BASE_URL + '/getDelegatedRecords';
const REVOKE_DELEGATED_ACCESS = BASE_URL + '/revokeDelegatedAccess';
const FREEZE_ALL_PRICES = BASE_URL + '/freezeAllPrices';
const GET_REGIONS_DATA = BASE_URL + '/regions';
const GET_ADMIN_DATA = BASE_URL + '/getAdminData';
const GET_STORES_DATA = BASE_URL + '/stores';
const GET_USERS_DATA = BASE_URL + '/users';
const ADD_REGION_DATA = BASE_URL + '/region';
const ADD_USER_DATA = BASE_URL + '/userInvite';
const ADD_STORE_DATA = BASE_URL + '/store';
const UPDATE_REGION = BASE_URL + '/region';
const DELETE_REGION = BASE_URL + '/region';
const DELETE_USER = BASE_URL + '/user';
const UPDATE_USER = BASE_URL + '/user';
const UPDATE_STORE = BASE_URL + '/store';
const GET_ECRI_DATA = BASE_URL + '/ecri-data';
const EXCLUDE_IN_LEASE_PRICING = BASE_URL + '/excludeInLeasePricing';
const APPROVE_IN_LEASE_PRICING = BASE_URL + '/approveInLeasePricing';
const UPDATE_PRICE_IN_LEASE_PRICING = BASE_URL + '/updatePriceInLeasePricing';
const RESET_OFFER_STATUS = BASE_URL + '/resetOfferStatus';
const EXPORT_IN_LEASE_PRICING = BASE_URL + '/exportInLeasePricing';
const GET_DISCOUNTS_URL = BASE_URL + '/getDiscounts';
const GET_DISCOUNT_OPTIONS_URL = BASE_URL + '/getDiscountOptions';
const OVERRIDE_UNIT_DISCOUNT_URL = BASE_URL + '/overrideUnitDiscount';
const GET_DISCOUNT_LOG_HISTORY_URL = BASE_URL + '/getDiscountLogHistory';
const GET_DISCOUNT_SUGGESTIONS_URL = BASE_URL + '/getDiscountSuggestions';
const APPROVE_DISCOUNT_SUGGESTION_URL = BASE_URL + '/approveDiscountSuggestion';
const GET_IN_LEASE_PRICE_SUGGESTIONS_URL =
  BASE_URL + '/getInLeasePriceSuggestions';
const APPROVE_IN_LEASE_PRICE_SUGGESTION_URL =
  BASE_URL + '/approveInLeasePriceSuggestion';

const api = {
  login: (credentials) => {
    return axios.post(LOGIN_URL, credentials);
  },

  getPriceCards: () => {
    return Promise.all([axios.post(PRICE_CARDS_URL), axios.get(KPI_URL)]);
  },
  getPriceCard: (input) => {
    return axios.post(PRICE_CARD_URL, input);
  },
  updateStatusAll: (input) => {
    return axios.post(ACCEPT_ALL_URL, input);
  },
  updateStatus: (input) => {
    return axios.post(ACCEPT_URL, input);
  },
  updatePrice: (input) => {
    return axios.post(UPDATE_PRICE_URL, input);
  },
  getReportsData: (input) => {
    return axios.post(REPORTS_DATA_URL, input);
  },
  getData: () => {
    return axios.get(URL);
  },
  logout: () => {
    return axios.get(LOGOUT_URL);
  },
  addComment: (input) => {
    return axios.post(ADD_COMMENT_URL, input);
  },
  raiseAlert: (input) => {
    return axios.post(RAISE_ALERT_URL, input);
  },
  getFeed: (input) => {
    return axios.post(GET_HISTORY_URL, input);
  },
  getSuggestions: () => {
    return axios.get(GET_SUGGESTIONS_URL);
  },
  approveSuggestion: (id) => {
    return axios.post(APPROVE_SUGGESTION_URL, { id });
  },
  fetchComments: (input) => {
    return axios.post(GET_COMMENTS_URL, input);
  },
  getNotifications: (lastId) => {
    return axios.get(`${GET_NOTIFICATIONS_URL}/${lastId}`);
  },
  markNotificationsRead: (ids) => {
    return axios.post(MARK_READ_URL, { ids });
  },
  getOverrideReportsData: (input) => {
    return axios.post(GET_OVERRIDE_REPORTS_DATA_URL, input);
  },
  resetPassword: (data) => {
    return axios.post(RESET_PASSWORD_URL, data);
  },
  changePassword: (data) => {
    return axios.post(CHANGE_PASSWORD_URL, data);
  },
  getCompetitorData: (data) => {
    return axios.post(GET_COMPETITORS_DATA, data);
  },
  getCompetitorsData: (data) => {
    return axios.get(`${COMPETITORS_DATA}?storeId=${data.storeId}`, data);
  },
  setCompetitorsData: (data) => {
    return axios.post(COMPETITORS_DATA, data);
  },
  forgotPassword: (data) => {
    return axios.post(FORGOT_PASSWORD_URL, data);
  },
  validateToken: (data) => {
    return axios.post(VALIDATE_TOKEN_URL, data);
  },
  getUsersWithRegion: () => {
    return axios.post(GET_USERS_WITH_REGIONS, {});
  },
  delegateAccess: (data) => {
    return axios.post(DELEGATE_ACCESS, data);
  },
  revokeAccess: (data) => {
    return axios.post(REVOKE_DELEGATED_ACCESS, data);
  },
  getDelegatedRecords: (data) => {
    return axios.post(GET_DELEGATED_RECORDS, data);
  },
  freezeAllPrices: (input) => {
    return axios.post(FREEZE_ALL_PRICES, input);
  },
  getAdminData: () => {
    return axios.get(GET_ADMIN_DATA);
  },
  getRegionsData: () => {
    return axios.get(GET_REGIONS_DATA);
  },
  getUsersData: () => {
    return axios.get(GET_USERS_DATA);
  },
  getStoresData: () => {
    return axios.get(GET_STORES_DATA);
  },
  addRegionData: (data) => {
    return axios.post(ADD_REGION_DATA, data);
  },
  addUserData: (data) => {
    return axios.post(ADD_USER_DATA, data);
  },
  addStoreData: (data) => {
    return axios.post(ADD_STORE_DATA, data);
  },
  updateRegion: (data) => {
    return axios.put(UPDATE_REGION, data);
  },
  updateUser: (data) => {
    return axios.put(UPDATE_USER, data);
  },
  updateStore: (data) => {
    return axios.put(UPDATE_STORE, data);
  },
  deleteRegion: (id) => {
    return axios.delete(`${DELETE_REGION}/${id}`);
  },
  deleteUser: (id) => {
    return axios.delete(`${DELETE_USER}/${id}`);
  },
  authenticateWithToken: () => {
    return axios.get(AUTHENTICATE_WITH_TOKEN_URL);
  },
  fetchEcriData: () => {
    return axios.get(GET_ECRI_DATA);
  },
  excludeInLeasePricing: (data) => {
    return axios.post(EXCLUDE_IN_LEASE_PRICING, data);
  },
  approveInLeasePricing: (data) => {
    return axios.post(APPROVE_IN_LEASE_PRICING, data);
  },
  updatePriceInLeasePricing: (data) => {
    return axios.post(UPDATE_PRICE_IN_LEASE_PRICING, data);
  },
  resetOfferStatus: (data) => {
    return axios.post(RESET_OFFER_STATUS, data);
  },
  getDiscounts: () => {
    return axios.get(GET_DISCOUNTS_URL);
  },
  getDiscountOptions: (data) => {
    return axios.get(GET_DISCOUNT_OPTIONS_URL, {
      params: data,
    });
  },
  getDiscountSuggestions: () => {
    return axios.get(GET_DISCOUNT_SUGGESTIONS_URL);
  },
  approveDiscountSuggestion: (id) => {
    return axios.post(APPROVE_DISCOUNT_SUGGESTION_URL, { id });
  },
  overrideUnitDiscount: (data) => {
    return axios.post(OVERRIDE_UNIT_DISCOUNT_URL, data);
  },
  getDiscountLogHistory: (unitIds) => {
    return axios.get(GET_DISCOUNT_LOG_HISTORY_URL, {
      params: { unitIds },
    });
  },
  getInLeasePriceSuggestions: () => {
    return axios.get(GET_IN_LEASE_PRICE_SUGGESTIONS_URL);
  },
  approveInLeasePriceSuggestion: (id) => {
    return axios.post(APPROVE_IN_LEASE_PRICE_SUGGESTION_URL, { id });
  },
  exportInLeasePricing: (params) => {
    return axios.get(EXPORT_IN_LEASE_PRICING, { params });
  },
};

export default api;
